import React, { useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import { CamasirhaneRoleProvider } from './context/CamasirhaneRoleContext';
import { handleGridArrowNavigation } from './utils/gridNavigation';
import { commitGridInput } from './utils/cellExpression';
import './styles/theme.css';
import './styles/shared.css';

const CamasirhaneLayout = () => {
  const rootRef = useRef(null);

  useEffect(() => {
    const root = rootRef.current;
    if (!root) return undefined;

    const onKeyDown = (e) => {
      if (e.key === 'Enter' && e.target instanceof HTMLInputElement && e.target.closest('table.data-grid')) {
        commitGridInput(e.target);
      }
      handleGridArrowNavigation(e);
    };

    root.addEventListener('keydown', onKeyDown, { capture: true });

    return () => {
      root.removeEventListener('keydown', onKeyDown, { capture: true });
    };
  }, []);

  return (
    <CamasirhaneRoleProvider>
      <div ref={rootRef} className="camasirhane-module min-h-full">
        <Outlet />
      </div>
    </CamasirhaneRoleProvider>
  );
};

export default CamasirhaneLayout;
